'use client';

import { useShowPasswordButtonStyles } from '@/shared/components/ui/input/password/show-password-button.styles';
import { useInputStore } from '@/shared/stores/ui/input/use-input.store';
import { Eye, EyeClosed } from '@phosphor-icons/react';
import { FC } from 'react';

type ShowPasswordButtonProps = {};

export const ShowPasswordButton: FC<ShowPasswordButtonProps> = () => {
  const { eyeIconStyle, showPasswordButtonStyle } =
    useShowPasswordButtonStyles();
  const { showPassword, toggleShowPassword } = useInputStore();

  return (
    <button
      type="button"
      className={showPasswordButtonStyle()}
      onClick={toggleShowPassword}
    >
      <Eye size={25} className={eyeIconStyle({ visible: showPassword })} />
      <EyeClosed
        size={25}
        className={eyeIconStyle({ visible: !showPassword })}
      />
    </button>
  );
};
